let lockCount = 0;

function applyBodyLock(): void {
  if (typeof document === 'undefined') return;
  if (lockCount > 0) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
}

export function lockBodyScroll(): void {
  lockCount += 1;
  applyBodyLock();
}

export function unlockBodyScroll(): void {
  lockCount = Math.max(0, lockCount - 1);
  applyBodyLock();
}

